import find from 'lodash/find';
import get from 'lodash/get';
import { registerDecorator, ValidationArguments, ValidationOptions } from 'class-validator';

import { store } from 'src/index';

export const IsEmailUnique = (validationOptions?: ValidationOptions) => (object: Object, propertyName: string) => {
  registerDecorator({
    name: 'isEmailUnique',
    target: object.constructor,
    propertyName: propertyName,
    options: validationOptions,
    validator: {
      validate: (currentPropertyValue: string, args: ValidationArguments) => {
        const emailLocalPart: string = get(args, 'object.emailLocalPart', '');
        const emailDomain = get(args, 'object.emailDomain', '');
        const id = get(args, 'object.id', '');

        if (!emailLocalPart || !emailDomain) {
          return false;
        }

        const state = store.getState();
        const emailAddresses = get(state, 'emailAddresses.values', []);
        const email = `${emailLocalPart.toLowerCase()}@${emailDomain}`;

        return !find(
          emailAddresses,
          emailAddress => emailAddress.type === 'EMAIL' && emailAddress.address === email && emailAddress.id !== id
        );
      },
      defaultMessage: () => 'This email name already exists. Please create a new one',
    },
  });
};
